import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ProtocolHDModel } from '../models/ProtocolHDModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class ProtocolHDService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getProtocolHD(prHdCode: string) {

      let params = new HttpParams();
        params = params.append("PrHdCode", prHdCode);
        const options = {
          params: params
      };
      return this.http.get<ProtocolHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/GetProtocolHD',options);
    }

    public AddProtocolHD(protocolHD: ProtocolHDModel) {
      return this.http.post<ProtocolHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/AddProtocolHD', protocolHD);
  }
  public delProtocolHD(prHdCode: string ) {

    let params = new HttpParams();
      params = params.append("prHdCode", prHdCode);

      const options = {
        params: params
    };
    return this.http.get<ProtocolHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/DeleteProtocolHD',options);
  }

  public getProtocolHDLookup(prHdCode: string, prHdName: string ) {
    let params = new HttpParams();
    params = params.append("prHdCode", prHdCode);
    params = params.append("prHdName", prHdName);

    const options = {
        params: params
    };
    return this.http.get<ProtocolHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/ProtocolHDLookup', options);
}
public getProtocolHDLookupToop(compCode: string ) {
  let params = new HttpParams();
  params = params.append("compCode", compCode);

  const options = {
      params: params
  };
  return this.http.get<ProtocolHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/ProtocolHDLookupTop', options);
}
 public getNextSerial(compCode: string) {
    let params = new HttpParams();

      params = params.append("compCode", compCode);
      const options = {
        params: params
    };
    return this.http.get<ProtocolHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProtocolHD/GetProtocolHDSerial',options);
  }
  }
